import { render, staticRenderFns } from "./proclamation.vue?vue&type=template&id=7196eec2&scoped=true&"
import script from "./proclamation.vue?vue&type=script&lang=js&"
export * from "./proclamation.vue?vue&type=script&lang=js&"
import style0 from "./proclamation.vue?vue&type=style&index=0&id=7196eec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196eec2",
  null
  
)

export default component.exports